import { createAuthClient } from '@nestle-npus-nbm/pup-script';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { PROFILE_CONFIG } from 'src/common/constants';

export type User = {
  ansiraId: string;
  email: string;
  emailVerified: boolean;
  lastName: string;
  name: string;
  fullName: string;
  ansiraUuid: string;
};

export const useAuth = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const { data, ...query } = useQuery<User | null>(
    ['getAuth'],
    async () => {
      try {
        if (!(await createAuthClient(PROFILE_CONFIG.auth0).isAuthenticated())) {
          return null;
        }

        const session = await createAuthClient(PROFILE_CONFIG.auth0).getSession();

        const user = session.idTokenAttributes;

        if (!user) {
          // eslint-disable-next-line no-console
          console.error('No user found.');
          return null;
        }

        return {
          ansiraId: String(user.ansiraId),
          email: user.email,
          emailVerified: user.email_verified,
          lastName: user.family_name,
          name: user.given_name,
          fullName: user.name,
          ansiraUuid: String(user.ansiraUuid),
        };
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        throw error;
      }
    },
    {
      enabled: isClient,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
  return { user: data, ...query };
};
